import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "/logo.png";

const FAQsPage = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Do invitees need to create an account?',
      answer: 'No. They can reserve a gift instantly without creating an account.'
    },
    {
      question: 'Will I know who picked which gift?',
      answer: 'Not until the gift is given — that\'s the surprise! The mystery of who chose what remains until you receive the gift on your special day.'
    },
    {
      question: 'Can invitees change their reserved gift later?',
      answer: 'Yes, they can unlock & pick another item anytime before the event.'
    },
    {
      question: 'Can I add gifts from any website?',
      answer: 'Yes. Works with all major Indian shopping sites including Amazon, Myntra, Nykaa, FirstCry, and more.'
    },
    {
      question: 'Are reminders sent automatically?',
      answer: 'Yes — invitees receive reminders at 7 days before, 3 days before, 1 day before, and on the day of the event.'
    },
    {
      question: 'What happens if two people try to select the same gift?',
      answer: 'Once someone selects a gift, it becomes "Reserved" and locked for others. This prevents duplicate gifts.'
    },
    {
      question: 'Can I share my wishlist with multiple people?',
      answer: 'Absolutely! Share your wishlist link via WhatsApp, SMS, email, or any messaging platform with as many people as you like.'
    },
    {
      question: 'Is the app free to use?',
      answer: 'Yes! Creating wishlists and sharing them is completely free.'
    },
    {
      question: 'Can I have multiple wishlists for different events?',
      answer: 'Yes! Create separate wishlists for birthdays, anniversaries, baby showers, and any other celebration.'
    },
    {
      question: 'How do I add collaborators to my wishlist?',
      answer: 'You can share event management access with others (like your spouse or partner) so they can help add items to the wishlist.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="glass-card mx-4 my-6 p-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-between">
            <img 
              src={LOGO_URL}
              alt="My Wishlist Logo" 
              className="h-16 w-auto cursor-pointer"
              onClick={() => navigate('/home')}
            />
            <Button
              onClick={() => navigate('/home')}
              variant="ghost"
              className="gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4" style={{color: '#ffffff'}}>
            Frequently Asked Questions
          </h1>
          <p className="text-xl" style={{color: '#ffffff'}}>Everything you need to know about My Wishlist</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="glass-card overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full p-6 text-left flex items-center justify-between hover:bg-white/50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-800 pr-4">{faq.question}</h3>
                {openIndex === index ? (
                  <ChevronUp className="w-6 h-6 text-gray-600 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-gray-600 flex-shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-xl mb-6" style={{color: '#ffffff'}}>Still have questions?</p>
          <Button
            onClick={() => navigate('/dashboard')}
            size="lg"
            style={{background: 'linear-gradient(135deg, #FF3E96 0%, #FF1744 100%)'}}
            className="text-white px-12 py-6 rounded-full text-xl font-bold shadow-xl"
          >
            Start Your Wishlist
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FAQsPage;